import React, { Component } from 'react'
import DownloadDataSelect from './DownloadDataSelect'; 
import RequestDataTable from './RequestDataTable';

class DownloadData extends Component {
  render() {
    return (
        <div >
          <DownloadDataSelect />
          <br />
          <RequestDataTable />
      </div>
    )
  }
}

export default DownloadData;
